import { render } from "./PagePVP.vue?vue&type=template&id=09767f39&scoped=true"
import script from "./PagePVP.vue?vue&type=script&lang=js"
export * from "./PagePVP.vue?vue&type=script&lang=js"

import "./PagePVP.vue?vue&type=style&index=0&id=09767f39&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09767f39"]])

export default __exports__